import React from 'react';
import { Modal, Box, Button } from '@mui/material';

const NodeConfigModal = ({ open, onClose, children }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    maxWidth: 900,
                    minWidth: 700,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',  // Set a maximum height relative to the viewport
                    overflowY: 'auto'   // Enable vertical scrolling for overflow content
                }}
            >
                <Box sx={{ pb: 2 }}>
                    {children}
                </Box>
            </Box>

        </Modal>
    );
};

export default NodeConfigModal;
